<template>
  <div class="login-page">
    <div
      class="card shadow forget-password-container"
      style="border-radius: 0.75rem"
    >
      <div class="card-body forget-card-body" style="border-radius: 0.75rem">
        <div class="mb-3">
          <h3 class="mb-0 font-weight-bold text-dark">Forgot Password?</h3>
          <p class="text-secondary">
            <small>Enter your email to create new Password</small>
          </p>
          <p v-if="errorMessage">
            <small class="text-danger">{{ errorMessage }}</small>
          </p>
          <p v-if="successMessage">
            <small class="text-success">{{ successMessage }}</small>
          </p>
        </div>
        <form action="" method="post" @submit.prevent="resetPassword()">
          <div class="mb-3">
            <input
              type="email"
              class="form-control"
              :class="{ 'border-danger': $v.email.$error || !$v.email.email }"
              placeholder="Email"
              v-model="email"
            />

            <div
              class="text-danger"
              v-if="$v.email.$error && !$v.email.required"
            >
              <small>Email Required</small>
            </div>
            <div class="text-danger" v-else-if="!$v.email.email">
              <small>This Field must be an Email</small>
            </div>
          </div>

          <div>
            <button
              type="submit"
              class="btn btn-danger btn-block rounded-pill"
              :disabled="submitStatus === 'PENDING'"
            >
              Send Email
            </button>
            <hr class="my-2" />
            <router-link
              :to="{ name: 'Login' }"
              type="submit"
              class="btn btn-outline-danger btn-block mb-2 rounded-pill"
            >
              Cancel
            </router-link>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import apiClient from "../../services/ApiServices";
import { required, email } from "vuelidate/lib/validators";

export default {
  data() {
    return {
      confirmation_path: window.location.origin + "/reset-password",
      email: "",
      successMessage: null,
      submitStatus: null,
      errorMessage: null,
    };
  },
  created() {
    document.title = "Forget Password - Manager Cabang";
  },
  validations: {
    email: {
      required,
      email,
    },
  },
  methods: {
    async resetPassword() {
      const data = new FormData();
      let confirmationPath = `${window.location.origin}/reset-password/`;
      if ((process.env?.VUE_APP_PUBLIC_PATH ?? "").length > 0) {
        confirmationPath = `${
          window.location.origin + process.env.VUE_APP_PUBLIC_PATH
        }reset-password/`;
      }

      data.append("email", this.email);
      data.append("confirmation_path", confirmationPath);
      this.$v.$touch();

      if (this.$v.$invalid) {
        this.submitStatus = "ERROR";
      } else {
        this.submitStatus = "PENDING";
        await apiClient
          .post("auth/forgotpassword/", data)
          .then((response) => {
            this.successMessage = response.data.message;
            this.submitStatus = "OK";
            this.errorMessage = "";
          })
          .catch((error) => {
            this.successMessage = "";
            this.submitStatus = "ERROR";
            this.errorMessage = error.data.message;
          });
      }
    },
  },
};
</script>
<style scoped>

.forget-password-container {
  width: 325px !important;
}
.forget-card-body {
  padding: 1.5rem 2rem;
}
.login-page {
  background-image: url("~@/assets/svg/wave.svg");
  background-size: cover;
  background-position: center;
}
@media (max-width: 601px) {
  .forget-password-container {
    width: 325px !important;
  }
}
@media (max-width: 325px) {
  .card {
    width: 100%!important;
    border-radius: 0!important;
  }
}
</style>